import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaWith } from 'theme'
import { Box } from 'shared'
import ProgressBar from '../ProgressBar'
import {
  CarouselButtonNext,
  CarouselButtonNextImage,
  CarouselButtonPrevious,
  CarouselButtonPreviousImage,
  CarouselControlsContainer,
} from './styles'
import previous from 'assets/images/howtobuy/previous-arrow.svg'
import next from 'assets/images/howtobuy/next-arrow.svg'

interface CarouselControlsProps {
  currentIndex: number
  visibleSlidesCount: number
  totalSlides: number
  goToNext: () => void
  goToPrev: () => void
  canGoPrev: boolean
  canGoNext: boolean
  mobileButtons?: boolean
  renderProgress?: React.ComponentType<any>
  progressBarText?: string
}

export default function CarouselControls({
  currentIndex,
  visibleSlidesCount,
  totalSlides,
  goToNext,
  goToPrev,
  canGoPrev,
  canGoNext,
  mobileButtons = true,
  renderProgress: ProgressComponent = ProgressBar,
  progressBarText = 'Step',
}: CarouselControlsProps) {
  const visibleSlides = Math.min(currentIndex + visibleSlidesCount, totalSlides)
  const progress = (visibleSlides / totalSlides) * 100
  const { t } = useTranslation('how-to-buy')
  const { upToMedium } = useMediaWith()

  const PreviousButton = canGoPrev ? (
    <CarouselButtonPrevious onClick={goToPrev}>
      <CarouselButtonPreviousImage src={previous} />
      {t('previous')}
    </CarouselButtonPrevious>
  ) : (
    <Box />
  )

  const NextButton = canGoNext ? (
    <CarouselButtonNext onClick={goToNext}>
      {t('next')}
      <CarouselButtonNextImage src={next} />
    </CarouselButtonNext>
  ) : (
    <Box />
  )

  const ProgressDisplay =
    totalSlides > visibleSlidesCount && ProgressComponent ? (
      <ProgressComponent totalSlides={totalSlides} visibleSlides={visibleSlides} progressBarText={progressBarText} />
    ) : null

  return (
    <>
      <CarouselControlsContainer>
        {(!upToMedium || mobileButtons) && PreviousButton}

        {(upToMedium && !mobileButtons) || !upToMedium ? ProgressDisplay : null}

        {(!upToMedium || mobileButtons) && NextButton}
      </CarouselControlsContainer>
    </>
  )
}
